import { useEffect, useRef } from 'react'
import { useResumenState } from '../ResumenContext'
import './ResumenFooter.css'
import { Button } from 'src/shared/components/forms'

const ResumenFooter = ({ buttonText, buttonForFormID, onClick, disabled }: { buttonText: string, buttonForFormID?: string, onClick?: () => void, disabled?: boolean }) => {

    const { setFooterHeight } = useResumenState()

    const footerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (footerRef.current) {
            setFooterHeight?.(footerRef.current.getBoundingClientRect().height)
        }
    }, [])


    return (
        <div className='shared-resumen__footer' ref={footerRef}>
            <div className='shared-resumen__footer__divider'></div>
            <Button disabled={disabled} onClick={onClick} form={buttonForFormID} text={buttonText} className='shared-resumen__footer__button' />
        </div>
    )
}

export default ResumenFooter